/**
 * Created by 小猪猪lover on 2019/1/10.
 */
(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider','$rootScopeProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('inventory', {
                parent: 'module',
                url: '/inventory',
                params:{page: null},
                data: {
                    authorities: ['ROLE_INVENTORY_WAREHOUSE']
                },
                views: {
                    'content': {
                        templateUrl: 'app/finishedWarehouse/inventory/inventory.html',
                        controller: 'InventoryController',
                        controllerAs: 'vm'
                    }
                }
            })
    }
})();
